<template>
  <div class="main">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <button @click="goBack" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </button>
          <div class="h5">
            {{ eventData.event_name }}
          </div>
          <h2 v-if="!editMode">Create a Day</h2>
          <h2 v-else>Edit Day</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col zero-form">
          <div class="input-block mb-x2">
            <label for="day-date">
              date
            </label>
            <input
              type="date"
              id="day-date"
              name="day-date"
              placeholder=""
              class="date-input"
              v-model="dayData.date"
              :class="{ 'has-error': errors.date }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.start">
              Please enter a date for the day
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="day-start">
              start time
            </label>
            <input
              type="time"
              id="day-start"
              name="day-start"
              placeholder=""
              class="date-input"
              v-model="dayData.start_time"
              :class="{ 'has-error': errors.start }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.end">
              Please enter a starting time for the day
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="day-end">
              end time
            </label>
            <input
              type="time"
              id="day-end"
              name="day-end"
              placeholder=""
              class="standard-date-input date-input"
              v-model="dayData.end_time"
              :class="{ 'has-error': errors.end }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.end">
              Please enter an ending time for the day
            </p>
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="postDay()" v-if="!editMode">
            Create Day
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="putDay()" v-if="editMode">
            Update Day
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import PageLoader from '@/components/PageLoader.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      dayId: '',
      eventData: {
        'event_name': '',
        'start_date': '',
        'end_date': '',
        'location': '',
        'floorplan_path': ''
      },
      dayData: {
        'date': '',
        'start_time': '',
        'end_time': '',
        'event_id': ''
      },
      errors: {
        'date': false,
        'start': false,
        'end': false
      },
      editMode: false
    }
  },
  created () {
    // get the jwt
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      this.eventId = this.$route.params.eventid
      this.getEvent()
    } else {
      this.$router.go(-1)
    }
    if (this.$route.params.dayid) {
      this.dayId = this.$route.params.dayid
      this.editMode = true
      this.getDay()
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getDay () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/days/' + this.dayId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.dayData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    postDay () {
      this.dayData.event_id = this.eventId
      axios
        .post(apiChoice + 'api/days', this.dayData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          this.$router.push({ path: '/jobs/' + this.eventId + '/days' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    putDay () {
      axios
        .put(apiChoice + 'api/days/' + this.dayId, this.dayData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          this.$router.push({ path: '/jobs/' + this.eventId + '/days' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    goBack () {
      // if profile => back to profile
      // if user create => back to users
      // if user edit => back to users dets
      if (this.editMode) {
        this.$router.push({ path: '/jobs/' + this.eventId + '/days/' + this.dayId })
      } else {
        this.$router.push({ path: '/jobs/' + this.eventId + '/days' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
